/**
 * Core Events Module
 * Exports the global event system for application-wide communication
 */

export { EventEmitter, globalEvents } from './event-emitter.js';

// Re-export as GlobalEvents for naming consistency
export { globalEvents as GlobalEvents } from './event-emitter.js';

// Common event names used across the application
export const Events = {
  // Authentication events
  AUTH_STATE_CHANGED: 'auth:state-changed',
  AUTH_LOGIN: 'auth:login',
  AUTH_LOGOUT: 'auth:logout',
  AUTH_ERROR: 'auth:error',
  AUTH_TOKEN_REFRESHED: 'auth:token-refreshed',
  AUTH_REDIRECT_REQUIRED: 'auth:redirect-required',
  
  // User events
  USER_CREATED: 'user:created',
  USER_UPDATED: 'user:updated',
  USER_DELETED: 'user:deleted',
  USER_PROFILE_UPDATED: 'user:profile-updated',
  
  // Organization events
  ORG_CREATED: 'org:created',
  ORG_UPDATED: 'org:updated',
  ORG_DELETED: 'org:deleted',
  ORG_MEMBER_ADDED: 'org:member-added',
  ORG_MEMBER_REMOVED: 'org:member-removed',
  
  // Verification events
  VERIFICATION_SENT: 'verification:sent',
  VERIFICATION_COMPLETED: 'verification:completed',
  VERIFICATION_FAILED: 'verification:failed',
  
  // Service events
  SERVICE_ERROR: 'service:error',
  SERVICE_LOADING: 'service:loading',
  SERVICE_READY: 'service:ready',
  
  // UI events
  UI_MODAL_OPEN: 'ui:modal-open',
  UI_MODAL_CLOSE: 'ui:modal-close',
  UI_TOAST_SHOW: 'ui:toast-show',
  UI_LOADING_START: 'ui:loading-start',
  UI_LOADING_END: 'ui:loading-end',
};